import API from '../api/PriceApi'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'

const GET_PRICE_DASHBOARD_REQUEST = 'priceDashboard/GET_PRICE_DASHBOARD_REQUEST'
const GET_PRICE_DASHBOARD_SUCCESS = 'priceDashboard/GET_PRICE_DASHBOARD_SUCCESS'
const GET_PRICE_DASHBOARD_FAILURE = 'priceDashboard/GET_PRICE_DASHBOARD_FAILURE'

const FETCH_PRICE_REQUEST = 'priceDashboard/FETCH_PRICE_REQUEST'
const FETCH_PRICE_SUCCESS = 'priceDashboard/FETCH_PRICE_SUCCESS'
const FETCH_PRICE_FAILURE = 'priceDashboard/FETCH_PRICE_FAILURE'

const initialState = {
  isLoading: true,
  fetchingId: null,
  error: {},
  dashboard: {
    total_prices: 0,
    active_prices: 0,
    total_groups: 0,
    success_rate_24h: 0,
    last_scrape_at: null,
    failed_items: [],
    recent_prices: []
  }
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_PRICE_DASHBOARD_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case GET_PRICE_DASHBOARD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        dashboard: action.payload
      }
    case GET_PRICE_DASHBOARD_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case FETCH_PRICE_REQUEST:
      return {
        ...state,
        fetchingId: action.payload
      }
    case FETCH_PRICE_SUCCESS:
      return {
        ...state,
        fetchingId: null
      }
    case FETCH_PRICE_FAILURE:
      return {
        ...state,
        error: action.error,
        fetchingId: null
      }
    default:
      return state
  }
}

export const getPriceDashboard = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_PRICE_DASHBOARD_REQUEST
      })

      const [dashboardRes, pricesRes] = await Promise.all([
        API.get(EndPoints.PRICE_DASHBOARD),
        API.get(EndPoints.PRICE)
      ])
      const prices = Array.isArray(pricesRes.data) ? pricesRes.data : []
      dispatch({
        type: GET_PRICE_DASHBOARD_SUCCESS,
        payload: {
          ...dashboardRes.data,
          recent_prices: prices,
          failed_items: prices.filter((p) => p.last_status === 'FAILED')
        }
      })
    } catch (err) {
      dispatch({
        type: GET_PRICE_DASHBOARD_FAILURE,
        error: err
      })
    }
  }
}

export const fetchPriceNow = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_PRICE_REQUEST,
        payload: id
      })
      await API.post(EndPoints.PRICE + `/${id}/fetch`)
      dispatch({
        type: FETCH_PRICE_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: FETCH_PRICE_FAILURE,
        error: err
      })
    }
  }
}
